module.exports = {
	"ha": "viha",
	"id": 5.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 81.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "49",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "41",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "38",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "30",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": true,
							"format": "24",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.51851851851852,
						"dataLabels": {
							"enabled": true,
							"format": "101",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "90",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.70370370370371,
						"dataLabels": {
							"enabled": true,
							"format": "85",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.888888888888886,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": true,
							"format": "216",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "195",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.55555555555556,
						"dataLabels": {
							"enabled": true,
							"format": "188",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.1111111111111,
						"dataLabels": {
							"enabled": true,
							"format": "169",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.22222222222223,
						"dataLabels": {
							"enabled": true,
							"format": "122",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": true,
							"format": "696",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.96551724137932,
						"dataLabels": {
							"enabled": true,
							"format": "645",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.93103448275862,
						"dataLabels": {
							"enabled": true,
							"format": "623",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.96551724137932,
						"dataLabels": {
							"enabled": true,
							"format": "587",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.6896551724138,
						"dataLabels": {
							"enabled": true,
							"format": "469",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -18.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.326530612244895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.481481481481477,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.89108910891089,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.823529411764707,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.722222222222221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.589743589743588,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.106382978723405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.810650887573964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.3275862068965525,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.4108527131782918,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.7784911717496,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.102214650766616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=60"
			},
			{
				"x": 9,
				"text": "30–39<br>n=108"
			},
			{
				"x": 15,
				"text": "40–49<br>n=225"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=725"
			}
		],
		"dataTable": {
			"< 30": [
				60,
				49,
				41,
				38,
				30,
				24
			],
			"30–39": [
				108,
				101,
				90,
				85,
				69,
				54
			],
			"40–49": [
				225,
				216,
				195,
				188,
				169,
				122
			],
			"≥ 50": [
				725,
				696,
				645,
				623,
				587,
				469
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_3.json
// module id = 338
// module chunks = 0